export default __webpack_public_path__ + "static/ionline-43024840e7badd09a2883e69b572c8d5.png";